<div class="section">
  <div class="example-loading-shade"
       *ngIf="isLoadingResults || isRateLimitReached">
    <nwb-spinner *ngIf="isLoadingResults" color="#4baed0"></nwb-spinner>
  </div>

  <div class="table-container">
    <table class="table table-rinnovi is-striped is-hoverable is-fullwidth" cdk-table [dataSource]="data"
           nwbSort
           [nwbSortActive]="filterGroup.get('sort')" [nwbSortStart]="filterGroup.get('order')">

      <ng-container cdkColumnDef="number">
        <th cdk-header-cell *cdkHeaderCellDef i18n="@@refPayment">Rif.</th>
        <td cdk-cell *cdkCellDef="let row">{{row.id}}</td>
      </ng-container>

      <ng-container cdkColumnDef="ufficio">
        <th cdk-header-cell *cdkHeaderCellDef nwb-sort-header i18n="@@office" class="is-hidden-mobile">Ufficio</th>
        <td cdk-cell *cdkCellDef="let row" class="is-hidden-mobile">{{row.luogo}}</td>
      </ng-container>

      <ng-container cdkColumnDef="contraente">
        <th cdk-header-cell *cdkHeaderCellDef i18n="@@payedBy" class="is-hidden-mobile">Pagato da</th>
        <td cdk-cell *cdkCellDef="let row" class="is-hidden-mobile">{{row.pagatoDa}}</td>
      </ng-container>

      <ng-container cdkColumnDef="data">
        <th cdk-header-cell *cdkHeaderCellDef nwb-sort-header i18n="@@startInsurance">
          Inizio validità
        </th>
        <td cdk-cell *cdkCellDef="let row">{{row.data | inizioValidita | date}}</td>
      </ng-container>

      <ng-container cdkColumnDef="data2">
        <th cdk-header-cell *cdkHeaderCellDef nwb-sort-header i18n="@@endInsurance">
          Fine validità
        </th>
        <td cdk-cell *cdkCellDef="let row">{{row.data | fineValidita | date}}</td>
      </ng-container>

      <ng-container cdkColumnDef="importo">
        <th cdk-header-cell *cdkHeaderCellDef nwb-sort-header i18n="@@amount" class="is-hidden-mobile">
          Importo
        </th>
        <td cdk-cell *cdkCellDef="let row" class="is-hidden-mobile">{{row.importoTessera | currency:'EUR'}}</td>
      </ng-container>
      <ng-container cdkColumnDef="scarica">
        <th cdk-header-cell *cdkHeaderCellDef nwb-sort-header>
          &nbsp;
        </th>
        <td cdk-cell *cdkCellDef="let row">
          <a class="has-text-primary" (click)="printLettera(row.id, row.data)">
            <span class="icon">
              <i class="fas fa-file-alt"></i>
            </span>
            <span i18n="@@download">Stampa</span>
          </a>
        </td>
      </ng-container>

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <nwb-paginator [length]="resultsLength"
                 [pageIndex]="filterGroup.get('pageIndex')"
                 [pageSize]="30"></nwb-paginator>
</div>
